<template>
  <div>
    <modal ref="formCadastroFornecedor">
      <div class="row">
        <div class="col-xs-12">
          <h4>
            {{ _traducao('global', 'cadastroFornecedor').toUpperCase() }}
            <button type="button" class="close" @click="$refs.formCadastroFornecedor.modalHide()">
              <span aria-hidden="true">&times;</span>
            </button>
          </h4>
          <hr />
        </div>
        <flFornecedor @atualiza-lista="() => {
          getFornecedores()
          $refs.formCadastroFornecedor.modalHide()
        }
          " ref="componenteCadastroFornecedor" />
      </div>
    </modal>
  </div>
</template>
<script>
import flFornecedor from '@/modules/layout/admin-geral/fornecedor/main.vue'
export default {
	name: 'ModalCadastroFornecedor',
	components: {
		flFornecedor
	},
	props: {

	},
	data() {
		return {

		}
	},
	methods: {
		abrirModalFornecedor() {
			this.$refs.formCadastroFornecedor.modalShow(80)
		}
	}
}
</script>

<style scoped></style>